import { defineStore } from "pinia";

interface icons {
  name: string;
  label: string;
  icon: string;
  activeIcon: string;
  pageName?: string;
}
interface NavIcons {
  icons: any;
  topNavIcons: icons[];
  footerNavIcons: icons[];
}

export const useNavIcons = defineStore('navIcons', {
  state: (): NavIcons => ({
    icons: [],
    topNavIcons: [],
    footerNavIcons: [],
  }),

  actions: {
    async getFooterNavIcons() {
      const runtimeConfig = useRuntimeConfig();
      const partnerId = runtimeConfig.public.partnerCode;
      const cart = useCart();
      const giftCart = useGiftCart();
      const cartItemCount = computed(() => {
        return giftCart.itemCount > 0 ? giftCart.itemCount : cart.itemCount;
      });
      const cartHref = computed(() => {
        return giftCart.itemCount > 0  ? "/collections/gift-cards/cart" : "/cart";
      });
      const data = await useAPIHandler("get", "/cms/nav_icons", { query: { partner_id: partnerId } });
      let sortedData = [];
      sortedData = data.data.sort(
        (a: any, b: any) => a.sequence_number - b.sequence_number
      );
      let NavItems;
      NavItems = sortedData
        .filter((x: any) => x.bottomNav)
        .map((x: any) => {
          const isCart = x.href === "/cart";
          return {
            name: isCart ? cartHref.value : x.href,
            label: x.name,
            icon: x.icon,
            activeIcon: x.activeIcon,
            bottomNav: x.bottomNav,
            topNav: x.topNav,
            ...(isCart && { badge: cartItemCount }),
          };
        });
      this.footerNavIcons = NavItems;
    },
    async getTopNavIcons(page: string) {
      const runtimeConfig = useRuntimeConfig();
      const partnerId = runtimeConfig.public.partnerCode;
      const cart = useCart();
      const giftCart = useGiftCart();
      const cartItemCount = computed(() => {
        return giftCart.itemCount > 0 ? giftCart.itemCount : cart.itemCount;
      });
      const cartHref = computed(() => {
        return giftCart.itemCount > 0  ? "/collections/gift-cards/cart" : "/cart";
      });
      const data = await useAPIHandler("get", "/cms/nav_icons", { query: { partner_id: partnerId }  });
      let sortedData = [];
      sortedData = data.data.sort(
        (a: any, b: any) => a.sequence_number - b.sequence_number
      );
      let NavItems;
      NavItems = sortedData
        .filter((x: any) => x.topNav)
        .map((x: any) => {
          const isCart = x.href === "/cart";
          return {
            name: isCart ? cartHref.value : x.href,
            label: x.name,
            icon: x.icon,
            pageName : x.pageName,
            activeIcon: x.activeIcon,
            bottomNav: x.bottomNav,
            topNav: x.topNav,
            ...(isCart && { badge: cartItemCount }),
          };
        });
      let pageIcons = NavItems.filter((x: icons) => x.pageName === page);
      NavItems = pageIcons.length > 0 ? pageIcons : NavItems.filter((x: icons) => x.pageName === 'common');

      watch([cartItemCount, cartHref], () => {
        NavItems.forEach((item: icons) => {
          if (item.label.toLowerCase() === "cart") {
            item.name = cartHref.value;
          }
        });
      }, { immediate: true });
      this.topNavIcons = NavItems;
    },
    async getIcons() {
      const runtimeConfig = useRuntimeConfig();
      const partnerId = runtimeConfig.public.partnerCode;
      const cart = useCart();
      const giftCart = useGiftCart();
      const cartItemCount = computed(() => {
        return giftCart.itemCount > 0 ? giftCart.itemCount : cart.itemCount;
      });
      const cartHref = computed(() => {
        return giftCart.itemCount > 0  ? "/collections/gift-cards/cart" : "/cart";
      });
      const { isMobile } = useDevice();
      const data = await useAPIHandler("get", "/cms/nav_icons", { query: { partner_id: partnerId }  });
      let sortedData = [];
      sortedData = data.data.sort(
        (a: any, b: any) => a.sequence_number - b.sequence_number
      );
      let NavItems;
      if (isMobile) {
        NavItems = sortedData
          .filter((x: any) => x.bottomNav)
          .map((x: any) => {
            const isCart = x.href === "/cart";
            return {
              name: isCart ? cartHref.value : x.href,
              label: x.name,
              icon: x.icon,
              activeIcon: x.activeIcon,
              bottomNav: x.bottomNav,
              topNav: x.topNav,
              ...(isCart && { badge: cartItemCount }),
            };
          });
      } else {
        NavItems = sortedData
          .filter((x: any) => x.topNav)
          .map((x: any) => {
             const isCart = x.href === "/cart";
            return {
              name: isCart ? cartHref.value : x.href,
              label: x.name,
              icon: x.icon,
              activeIcon: x.activeIcon,
              bottomNav: x.bottomNav,
              topNav: x.topNav,
              ...(isCart && { badge: cartItemCount }),
            };
          });
      }

      this.icons = NavItems;
    },
  },
});
